// @lazy-load
export async function componentOne() {
  const module = await import("/Users/egr/Desktop/NPMS/infile-lazyload-split-loader/example/dist/componentOne.lazy.js");
  return module.default() || module;
}
;

// @lazy-load
export const componentTwo = async function componentTwo() {
  const module = await import("/Users/egr/Desktop/NPMS/infile-lazyload-split-loader/example/dist/componentTwo.lazy.js");
  return module.default() || module;
};